import React, { useState, useEffect, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReservationHotelListTable from "./ReservationHotelListTable";
import * as HTTPManager from './HTTPManager';
import { useRecoilValue, useSetRecoilState } from "recoil";
import { ACT } from "./recoil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { jwtDecode } from "jwt-decode";

function PageHotelInfo() {
  const navigate = useNavigate();

  const [reservationFilterInfo, setReservationFilterInfo] = useState([]);

  const accessToken = useRecoilValue(ACT);
  const setACT = useSetRecoilState(ACT);

  const endTimeRef = useRef(null);
  const [minute, setMinute] = useState(null);
  const [second, setSecond] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (accessToken === "") {
      endTimeRef.current = 0;
      return;
    }

    const responsePayload = jwtDecode(accessToken);
    const expireTime = responsePayload.exp;
    endTimeRef.current = expireTime;
  });

  async function fetchData() {
    let response = await HTTPManager.GetReservationList({
      accessToken: accessToken,
    });

    if (response !== undefined && response !== null) {
      if (response.code === 1100) {
        setACT("");
        setShowModal(true);
      }

      if (response.result?.length > 0) {
        response.result.sort((a, b) => {
          // 시작일 빠른순 정렬
          if (new Date(a.startDate.replace(" ", "T")) > new Date(b.startDate.replace(" ", "T")))
            return 1;
          if (new Date(a.startDate.replace(" ", "T")) < new Date(b.startDate.replace(" ", "T")))
            return -1;

          // 종료일 빠른순 정렬
          if (new Date(a.endDate.replace(" ", "T")) > new Date(b.endDate.replace(" ", "T")))
            return 1;
          if (new Date(a.endDate.replace(" ", "T")) < new Date(b.endDate.replace(" ", "T")))
            return -1;
        });

        for (let i = 0; i < response.result.length; i++) {
          response.result[i].tourId = response.result[i].tourId?.slice(0, 5) ?? "";
          response.result[i].startDate = response.result[i].startDate.slice(0, 10);
          response.result[i].endDate = response.result[i].endDate.slice(0, 10);
          response.result[i].guide = response.result[i].guide;
          response.result[i].countryId = response.result[i].countryId === 2 ? "인도네시아" : response.result[i].countryId === 3 ? "필리핀" : "기타";

          let dayCount = (new Date(response.result[i].endDate.replace(" ", "T")) - new Date(response.result[i].startDate.replace(" ", "T"))) / 86400000 + 1;
          response.result[i].nights = dayCount - 1;

          // 인원수 부정확하여 제거
          //let paxStr = response.result[i].pax.split(/\[|\(/);
          //response.result[i].pax = response.result[i].pax.replace(regex, "");

          //var regex = /[^0-9>+]/gi;
          //response.result[i].pax = paxStr[0].replaceAll('명', '');
        }

        setReservationFilterInfo(response.result);
      }
    }
  }

  useEffect(() => {
    fetchData();

    const authExpireInterval = setInterval(() => {
      const currentTime = Math.floor(Date.now() / 1000);
      const timeRemain = endTimeRef.current === 0 ? 0 : endTimeRef.current - currentTime;
      const minuteRemaining = Math.floor(timeRemain / 60);
      const secondRemaining = timeRemain % 60;

      if (timeRemain < 0) {
        clearInterval(authExpireInterval);
        // 이전 페이지 기록 X
        setACT("");
        setShowModal(true);
      } else {
        setMinute(String(minuteRemaining).padStart(2, "0"));
        setSecond(String(secondRemaining).padStart(2, "0"));
      }
    }, 1000);

    return () => clearInterval(authExpireInterval);
  }, [])

  const minWidth = 100;
  const columns = useMemo(
    () => [
      // {
      //   accessor: "tourId",
      //   Header: "관리번호",
      //   minWidth: minWidth,
      //   style: {
      //     border: "1px solid rgb(0, 0, 0)",
      //     textAlign: "center",
      //     fontSize: 13,
      //   },
      //   index: 0,
      // },
      {
        accessor: "hotelName",
        Header: "호텔명",
        minWidth: minWidth,
        style: {
          border: "1px solid rgb(0, 0, 0)",
          textAlign: "center",
          fontSize: 13,
        },
        index: 1,
      },
      {
        accessor: "reservationNo",
        Header: "예약번호",
        minWidth: minWidth,
        style: {
          border: "1px solid rgb(0, 0, 0)",
          textAlign: "center",
          paddingLeft: 5,
          fontSize: 13,
        },
        index: 9,
      },
      {
        accessor: "startDate",
        Header: "체크인",
        minWidth: minWidth,
        style: {
          border: "1px solid rgb(0, 0, 0)",
          textAlign: "center",
          fontSize: 13,
        },
        index: 2,
      },
      {
        accessor: "endDate",
        Header: "체크아웃",
        minWidth: minWidth,
        style: {
          border: "1px solid rgb(0, 0, 0)",
          textAlign: "center",
          fontSize: 13,
        },
        index: 3,
      },
      {
        accessor: "nights",
        Header: "숙박일수",
        minWidth: minWidth,
        style: {
          border: "1px solid rgb(0, 0, 0)",
          textAlign: "center",
          fontSize: 13,
        },
        index: 4,
      },
      // {
      //   accessor: "pax",
      //   Header: "인원",
      //   minWidth: minWidth,
      //   style: {
      //     border: "1px solid rgb(0, 0, 0)",
      //     textAlign: "center",
      //     fontSize: 13,
      //   },
      //   index: 5,
      // },
      {
        accessor: "roomType",
        Header: "객실 타입",
        minWidth: minWidth + 200,
        style: {
          border: "1px solid rgb(0, 0, 0)",
          textAlign: "left",
          paddingLeft: 5,
          fontSize: 13,
        },
        index: 6,
      },
      // {
      //   accessor: "reservationState",
      //   Header: "예약 상태",
      //   minWidth: minWidth,
      //   style: {
      //     border: "1px solid rgb(0, 0, 0)",
      //     textAlign: "left",
      //     paddingLeft: 5,
      //     fontSize: 13,
      //   },
      //   index: 7,
      // },
      // {
      //   accessor: "breakfast",
      //   Header: "조식",
      //   minWidth: minWidth,
      //   style: {
      //     border: "1px solid rgb(0, 0, 0)",
      //     textAlign: "left",
      //     paddingLeft: 5,
      //     fontSize: 13,
      //   },
      //   index: 8,
      // },
      // {
      //   accessor: "etd",
      //   Header: "출국편",
      //   minWidth: minWidth,
      //   style: {
      //     border: "1px solid rgb(0, 0, 0)",
      //     textAlign: "left",
      //     paddingLeft: 5,
      //     fontSize: 13,
      //   },
      //   index: 9,
      // },
      {
        accessor: "guide",
        Header: "가이드",
        minWidth: minWidth + 100,
        style: {
          border: "1px solid rgb(0, 0, 0)",
          textAlign: "left",
          paddingLeft: 5,
          fontSize: 13,
        },
        index: 10,
      },
      {
        accessor: "countryId",
        Header: "국가",
        minWidth: minWidth + 100,
        style: {
          border: "1px solid rgb(0, 0, 0)",
          textAlign: "center",
          paddingLeft: 5,
          fontSize: 13,
        },
        index: 10,
      },
    ], []);

  const data = useMemo(() => reservationFilterInfo, [reservationFilterInfo]);
  const a4Notice = useRef();

  return (
    <div className="flex flex-col h-full w-full bg-[white] relative">
      <div className="flex flex-row w-full px-2 justify-center my-3 text-[20px] font-bold items-center">
        KTS 예약정보
        {
          minute !== null && second !== null &&
          <div className="absolute right-10 md:right-1 text-[15px] rounded-full bg-yellow-300 text-yellow-900 px-3 py-1">
            {minute !== null && `${minute}:`}{second !== null && `${second}`}
          </div>
        }
      </div>
      <div className="flex flex-col pl-44 py-5 md:pl-1">
        <div className="flex flex-row items-center gap-3">
          <FontAwesomeIcon icon={faCircle} style={{ color: "#000", width: 5 }} />
          <div className="text-[14px]">크로스 체크용 페이지입니다.</div>
        </div>
        <div className="flex flex-row items-center gap-3 ">
          <FontAwesomeIcon icon={faCircle} style={{ color: "#000", width: 5 }} />
          <div className="text-[14px]">호텔측 예약 상황과 다르다면 문의 부탁드립니다.</div>
        </div>
        <div className="flex flex-row items-center gap-3 ">
          <FontAwesomeIcon icon={faCircle} style={{ color: "#000", width: 5 }} />
          <div className="text-[14px]">비어있는 정보는 업데이트 예정입니다.</div>
        </div>
        <div className="flex flex-row items-center gap-3 ">
          <FontAwesomeIcon icon={faCircle} style={{ color: "#000", width: 5 }} />
          <div className="text-[14px]">번호인증은 <span className="text-[red] font-bold">1시간</span> 동안 유효하며 1시간이 지나면 <span className="text-[red] font-bold">재인증</span>이 필요합니다.</div>
        </div>
        <div className="flex flex-row items-center gap-3 ">
          <FontAwesomeIcon icon={faCircle} style={{ color: "#000", width: 5 }} />
          <div className="text-[14px]">이미 지난 기록은 정확하지 않을 수 있습니다.</div>
        </div>
        <div className="flex flex-row items-center gap-3 ">
          <FontAwesomeIcon icon={faCircle} style={{ color: "#000", width: 5 }} />
          <div className="flex flex-row text-[14px] font-bold gap-1">
            <span className="text-[#7f7f7f]">[종료]</span>
            <span className="text-[#00CD3C]">[진행중]</span>
            <span className="text-[#0570DB]">[예정]</span>
          </div>
        </div>
      </div>
      <div ref={a4Notice} className="flex flex-col h-full w-full text-[13px] bg-[white]">
        <div className="flex flex-row justify-center w-full h-full">
          <div className="flex bg-[#fff] w-[200px] items-center justify-center h-full"></div>
          <div className="flex w-full h-full">
            {/* sticky 상위에(부모에) h-full 적용 */}
            {reservationFilterInfo?.length > 0 && <ReservationHotelListTable columns={columns} data={data} />}
          </div>
          <div className="flex bg-[#fff] w-[200px] items-center justify-center h-full"></div>
        </div>
        <div className="h-[60px]">

        </div>
      </div>
      {
        showModal &&
        <div className="fixed w-full bg-[#000000aa]">
          <div className="flex flex-col my-auto items-center h-screen">
            <div className="m-auto w-[400px] h-[200px]">
              <div className="h-[165px] bg-[white] rounded-t-lg flex flex-col items-center justify-center font-bold text-[25px]">
                <div>인증만료</div>
                <div className="text-[14px] text-[#909198]">홈 화면으로 돌아갑니다.</div>
              </div>
              <div className="flex bg-[#909198] text-[white] h-[35px] items-center justify-center text-[14px] font-bold rounded-b-lg cursor-pointer"
                onClick={() => {
                  setACT("");
                  navigate("/", { replace: true });
                }}
              >닫기</div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default PageHotelInfo;
